import { render, staticRenderFns } from "./blogtags.vue?vue&type=template&id=74543f1e&"
import script from "./blogtags.vue?vue&type=script&lang=js&"
export * from "./blogtags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74543f1e')) {
      api.createRecord('74543f1e', component.options)
    } else {
      api.reload('74543f1e', component.options)
    }
    module.hot.accept("./blogtags.vue?vue&type=template&id=74543f1e&", function () {
      api.rerender('74543f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eg3tNOmVeG0q/JS/comp/blogtags.vue"
export default component.exports